import { ITemplateProps } from 'modules/_common/models';
import API from 'services/api';

import { IMailTask } from '../models/IMailTask';

export const createMailTask = ({
  reservationId,
  templateId,
  isRenter,
}: ITemplateProps): Promise<IMailTask> => {
  return API.post(`api/accommodation/templates/${templateId}/calculations/${reservationId}`, null, {
    params: { isRenter },
  }).then(response => response?.data);
};
